import React from 'react';
import './WeeklyOverview.css';
import { getHabitsForDate, calculateDayCompletion, getStartOfDay } from '../utils/habitScheduler';

const WeeklyOverview = ({ personalizedHabits, habitSchedules, currentDate }) => {
  const getWeekDates = (date) => {
    const startOfWeek = new Date(date);
    const day = startOfWeek.getDay();
    const diff = startOfWeek.getDate() - day; // First day is Sunday
    startOfWeek.setDate(diff);
    
    const weekDates = [];
    for (let i = 0; i < 7; i++) {
      const weekDate = new Date(startOfWeek);
      weekDate.setDate(startOfWeek.getDate() + i);
      weekDates.push(getStartOfDay(weekDate));
    }
    return weekDates;
  };

  const weekDates = getWeekDates(currentDate);
  const today = getStartOfDay();
  
  const dayNames = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

  const getDayData = (date) => {
    const habits = getHabitsForDate(personalizedHabits, habitSchedules, date);
    const completion = calculateDayCompletion(habits);
    const isToday = date.getTime() === today.getTime();
    const isPast = date < today;
    const isFuture = date > today;
    
    return {
      date,
      habits,
      completion,
      isToday,
      isPast,
      isFuture,
      dayName: dayNames[date.getDay()],
      dayNumber: date.getDate()
    };
  };

  const weekData = weekDates.map(getDayData);
  const weeklyAverage = Math.round(
    weekData.filter(day => day.isPast || day.isToday)
      .reduce((sum, day) => sum + day.completion, 0) / 
    weekData.filter(day => day.isPast || day.isToday).length || 0
  );

  return (
    <div className="weekly-overview">
      <div className="weekly-header">
        <h3>This Week's Progress</h3>
        <div className="weekly-average">
          <span className="average-label">Weekly Average</span>
          <span className="average-value">{weeklyAverage}%</span>
        </div>
      </div>
      
      <div className="week-grid">
        {weekData.map((day, index) => (
          <div 
            key={index}
            className={`day-cell ${day.isToday ? 'today' : ''} ${day.isPast ? 'past' : ''} ${day.isFuture ? 'future' : ''}`}
          >
            <div className="day-header">
              <span className="day-name">{day.dayName}</span>
              <span className="day-number">{day.dayNumber}</span>
            </div>
            
            <div className="day-progress">
              <div className="progress-ring">
                <svg width="40" height="40">
                  <circle
                    cx="20"
                    cy="20"
                    r="16"
                    stroke="rgba(226, 232, 240, 0.3)"
                    strokeWidth="3"
                    fill="transparent"
                  />
                  <circle
                    cx="20"
                    cy="20"
                    r="16"
                    stroke={day.completion >= 100 ? '#10b981' : day.completion >= 75 ? '#f59e0b' : '#6b7280'}
                    strokeWidth="3"
                    fill="transparent"
                    strokeDasharray={`${2 * Math.PI * 16}`}
                    strokeDashoffset={`${2 * Math.PI * 16 * (1 - day.completion / 100)}`}
                    strokeLinecap="round"
                    className="progress-circle"
                  />
                </svg>
                <span className="progress-percentage">{day.completion}%</span>
              </div>
            </div>
            
            <div className="day-habits">
              <span className="habit-count">
                {day.habits.filter(h => h.isCompleted).length}/{day.habits.length}
              </span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default WeeklyOverview;
